<style lang="scss">
.person-picker {
    display: flex;
    align-items: center;
    max-width: 600px;

    :global(.select-box) {
        flex: 1 1 100%;
    }

    :global(button) {
        flex: 0 0;
        margin-left: 16px;
    }
}
</style>
<script lang="ts">
import { createEventDispatcher } from 'svelte';
import type { SelectItem } from './SelectBox.svelte';
import store from '../store/person';
import SelectBox from './SelectBox.svelte';
import Button from './Button.svelte';

export let selected: string | undefined;
export let removable = false;
let current: string | undefined;
let persons: SelectItem[];
const dispatch = createEventDispatcher();

$: current = selected;
$: persons = $store.persons ? $store.persons.map(person => ({ id: person.id, value: person.name })) : [];

function onChange(evt: CustomEvent) {
    dispatch('update', evt.detail);
}

function onEditStart() {
    const person = $store.persons.find(p => p.id === current);
    if (person) {
        dispatch('edit', person);
    }
}
</script>
<div class="person-picker">
    <SelectBox items={persons} bind:selected on:change={onChange} placeholder="Выберите лектора" />
    <Button type="button" on:click={onEditStart} disabled={!current}>✏️</Button>
    <Button type="button" on:click={() => dispatch('add')}>➕</Button>
    <Button type="button" on:click={() => dispatch('remove')} disabled={!removable}>🗑</Button>
</div>
